<template>
  <div ref="projectcount"
       class="pbr-index-chart">
<Empty></Empty>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import {chartColors} from '../../../analysis/constant'
import Mixin from '../mixin'
import ResizeObserver from 'resize-observer-polyfill'
export default {
  name: 'pbrChartProjectCount',
  mixins: [Mixin],
  inject: ['chartDatas'],
  props:{
    height:{type: Number}
  },
  data () {
    return {
      projectCountChart: null,
      optionProjectcount: null,
      isResize: false,
      // data: [{
      //   country: '俄罗斯',
      //   countArr: [
      //     { year: '2015', count: 43.3 },
      //     { year: '2016', count: 85.8 },
      //     { year: '2017', count: 93.7 }
      //   ]
      // },
      // {
      //   country: '伊朗',
      //   countArr: [
      //     { year: '2015', count: 83.1 },
      //     { year: '2016', count: 73.4 },
      //     { year: '2017', count: 55.1 }
      //   ]
      // },
      // {
      //   country: '哈萨克斯坦',
      //   countArr: [
      //     { year: '2015', count: 86.4 },
      //     { year: '2016', count: 65.2 },
      //     { year: '2017', count: 82.5 }
      //   ]
      // }, {
      //   country: '巴基斯坦',
      //   countArr: [
      //     { year: '2015', count: 72.4 },
      //     { year: '2016', count: 53.9 },
      //     { year: '2017', count: 39.1 }
      //   ]
      // }
      // ]
    }
  },
  computed: {
    chartData () {
      const projectChartData = this.chartDatas.projectChartData()
      // return projectChartData.projectNumChart === {} ? [{name: '', num: 0, percentage: 0}] : projectChartData.projectNumChart
      if (projectChartData.hasOwnProperty('projectNumChart') && projectChartData.projectNumChart.length > 0) {
        return projectChartData.projectNumChart
      }
      return [{name: '', nums: [0], times: [0]}]
    }
  },
  methods: {
    drawChart (theme = 'light') {
      let self = this
      if (this.projectCountChart) {
        this.projectCountChart.dispose()
      }
      if(!this.$refs.projectcount){
        return
      }
      let countContrastDom = this.$refs.projectcount
      this.projectCountChart = echarts.init(countContrastDom, theme, {devicePixelRatio: 2.5, height: this.height})
      this.projectCountChart.setOption(this.optionProjectcount)
      // let height = window.getComputedStyle(document.querySelector('.pbr-index-charts')).height
      // this.projectCountChart.resize({height})
      this.projectCountChart.on('click', (param) => {
        // this.$emit('project-count-chart-click', param)
        // self.dispatch('pbrIndex', 'filterData', {module: 'xm', countryName: param.name})
      })


      let that = this;
      let countContrastObserver = new ResizeObserver((entries) => {
        if (that.isResize) {
          that.projectCountChart.resize()
          if (entries && entries.length > 0 && entries[0].borderBoxSize[0].blockSize > 0) {
            that.isResize = false;
          }
        }
      })
      countContrastObserver.observe(countContrastDom);
    },
    generateOptions () {
      this.optionProjectcount = {
        color: chartColors,
        title: {
          show: this.showTitle,
          text: this.$t('charts.home.project.number'),
          left: 'center',
          top:0
        },
        tooltip: {
          trigger: 'axis',
          confine: true,
          className: 'pbr-echarts-formatter-box',
          textStyle:{
            color:"inherit"
          },
          backgroundColor: "#fff",
          shadowBlur: 10,
          shadowColor: "rgba(0, 0, 0, .2)",
          shadowOffsetX: 1,
          shadowOffsetY: 2,
          borderRadius: 4,
          borderWidth: 1
        },
        legend: {
          type: 'scroll',
          data: this.chartData.map(d => d.name),
          itemHeight: 8,
          itemWidth: 15,
          top: 26
        },
        grid: {
          left: '3%',
          right: 20,
          bottom: 0,
          top: this.showTitle ? 56 : 20,
          containLabel: true
        },

        // dataset: this.chartData.map(d => { return { source: d.countArr } }),
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: [...new Set(this.chartData.map(d => d.times).reduce((pre, cur) => pre.concat(cur)))],
          axisLabel: {
            showMaxLabel: true,
            alignMinLabel: 'left',
            alignMaxLabel: 'right'
          }
        },
        yAxis: { type: 'value',min: function (value) {
            let num = 0
            if (value.min === 0) {
              return num
            } else if (value.min.toString().length < 2) {
              return value.min - 1
            } else if (value.min.toString().length < 3) {
              return value.min - 10
            } else {
              num = 10 ** (value.min.toString().length - 2)
              return Math.floor(value.min / num) * num
            }
          } },
        series: this.chartData.map((d, i) => {
          return {
            name: d.name,
            type: 'line',
            data: d.nums,
            areaStyle: {opacity:.1},
            smooth:true
          }
        })
      }
    },
    resize () {
      this.isResize = true
      this.projectCountChart.resize()
    }
  },
  mounted () {
    this.generateOptions()
    this.drawChart(this.theme)
  },
  activated () {
    this.generateOptions()
    this.drawChart(this.theme)
  },
  watch: {
    '$store.state.brpaModule.theme': {
      handler: function (val) {
        this.generateOptions()
        this.drawChart(val || 'white')
      },
      immediate:true
    },
    chartData: {
      handler (newValue, oldValue) {
        if (newValue.length === 0) {
          if (this.projectCountChart) {
            this.projectCountChart.dispose()
          }
        } else {
          this.generateOptions()
          this.drawChart(this.theme)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
